import React, { useRef, useState, useCallback, useEffect } from 'react';
import { 
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Row,
	Col,
	Button,
} from 'reactstrap';

import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import SocialSignup from './socialSignup';

import { useHistory } from "react-router-dom";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import './signUp.css';


const API_URL = process.env.REACT_APP_API_URL_BASE;
const IUBENDA_API_KEY_MMD_DE = process.env.REACT_APP_IUBENDA_API_KEY_MMD_DE;

const sidebarBackground = {
	backgroundRepeat: "no-repeat",
	backgroundPosition: "bottom center"
};

const linkStyle = {
	fontWeight: 600,
	color: "#2bcfe0"
};

const getIubendaConsInstructions = () => {
	const consInstructions = window._iub && window._iub.cons_instructions;
	if (!consInstructions || typeof consInstructions.push !== 'function') {
		return null;
	}
	return consInstructions;
};

const initSignupIubendaConsent = (apiKey) => {
	const consInstructions = getIubendaConsInstructions();
	if (!consInstructions || !apiKey) {
		return;
	}
	consInstructions.push(["init", {
		api_key: apiKey,
		logger: "console",
		log_level: "warn",
	}]);
};

const submitSignupConsentToIubenda = () => {
	try {
		const consInstructions = getIubendaConsInstructions();
		if (!consInstructions) {
			return;
		}
		consInstructions.push(["submit", {
			form: {
				selector: document.getElementById("signup-form"),
				map: {
					subject: {
						first_name: "first_name",
						last_name: "last_name",
						email: "email"
					},
					exclude: ["password", "confirm_password"],
				}
			},
			consent: {
				legal_notices: [{
					identifier: "privacy_policy",
				},
				{
					identifier: "cookie_policy",
				},
				{
					identifier: "terms",
				}
			],
			}
		}]);
	} catch (error) {
		// Consent recording must not block registration.
	}
};

const SignUp = () => {
  const history = useHistory();
  const formRef = useRef();
  const iubendaInitializedRef = useRef(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [ reCaptcha, setReCaptcha ] = useState('');
  const isMmdDeTenant = true;

  useEffect(() => {
	if (iubendaInitializedRef.current || !isMmdDeTenant) {
		return;
	}
	const apiKey = String(IUBENDA_API_KEY_MMD_DE || '').trim();
	if (!apiKey) {
		return;
	}
	iubendaInitializedRef.current = true;
	initSignupIubendaConsent(apiKey);
  }, [isMmdDeTenant]);

  const handleReCaptchaVerify = useCallback((event) => {
	if (!executeRecaptcha) {
		console.log('Execute recaptcha not yet available')
		return
	}
	(async () => {
		try {
			const token = await executeRecaptcha('authentication')
			setReCaptcha(token);
			if (formRef.current) {
				formRef.current.handleSubmit();
			}
		} catch (error) {
			console.log(error.response)
		}
	})()
	}, [executeRecaptcha]);

  const registerUser = (payload, { setStatus, setSubmitting }) => {
	axios.post(`${API_URL}users/register`, payload).then(res => {
		const status = Number(res.status);
		if (status >= 200 && status < 300) {
			setSubmitting(false);
			if (isMmdDeTenant) {
				submitSignupConsentToIubenda();
			}
			history.push('/authentication/signup-successfull');
			return;
		}

		setSubmitting(false);
		if (status === 400 && res.data && res.data.detail) {
			setStatus(res.data.detail);
			return;
		}
		setStatus('Something went wrong. Please try again.');
	}).catch(function (error) {
		setSubmitting(false);
		if (error.response) {
			const errorData = error.response.data;
			const errorMsg = errorData && errorData.detail;
			if (errorMsg) {
				setStatus(typeof errorMsg === 'string' ? errorMsg : 'Something went wrong. Please try again.');
				return;
			}
		}
		setStatus('Something went wrong. Please try again.');
	});
  };

	const handleKeyPress = (event) => {
		if (event.key === 'Enter') {
		  handleReCaptchaVerify();
		}
	};

  return (
	<div className="auth-wrapper d-flex align-items-center" style={sidebarBackground}>
		<div className="container">
			<div id="signupform">
				<Row className="no-gutters justify-content-center">
					<Col md="6" lg="4" className="bg-primary text-white">
						<div className="p-4">
							<h2 className="display-5">Move Music<br /> 
							<span className="text-cyan font-bold display-6">Leading Music Distribution and Marketing app</span></h2><br /><br /><br />
							<p>How it works?<br /><br />
							<span className="text-cyan">1. Create your free demo account</span><br /><br />
							<span className="text-cyan">2. Preview our unique distribution, maketing and promo features</span><br /><br />
							<span className="text-cyan">3. If you like it, <b className="text-white">JOIN US!</b> (Join possible from our demo dashboard)</span><br /><br />
							</p>

							
						</div>
					</Col>
					<Col md="6" lg="4" className="bg-white">
						<div className="p-4">
							<h3 className="font-medium mb-3">Register Your Free Demo Account</h3>
							<Formik
								innerRef={formRef}
								initialValues={{
									first_name: '',
									last_name: '',
									email: '',
									password: '',
									confirm_password: '',
									acceptTermsOfUsage: false,
									acceptPrivacyPolicy: false,
									acceptCookiePolicy: false,
								}}
								validationSchema={Yup.object().shape({
									first_name: Yup.string().required('First Name is required'),
									last_name: Yup.string().required('Last Name is required'),
									email: Yup
									.string().required('Email is required').email('Email is invalid'),
									password: Yup
									.string()
									.required('Please enter your password')
									.matches(
										/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
										"Password must contain atleast 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
									),
									confirm_password: Yup.string().oneOf([Yup.ref("password"), null], "Password and Confirm password must match").required('Please confirm your password'),
									acceptTermsOfUsage: Yup.bool().oneOf([true], 'Accepting Terms of Usage is required'),
									acceptPrivacyPolicy: Yup.bool().oneOf([true], 'Accepting Privacy Policy is required'),
									acceptCookiePolicy: Yup.bool().oneOf([true], 'Accepting Cookie Policy is required'),
								})}
								onSubmit={({ first_name, last_name, email, password }, { setStatus, setSubmitting }) => {
									setStatus();

									const recaptchaPayload = {
										recaptcha: reCaptcha
									};

									const payload = {
										firstname: first_name,
										lastname: last_name,
										email: email,
										password: password,
									};

									axios.post(`${API_URL}users/validate-google-recaptcha/`, recaptchaPayload).then(res => {
										if (res.status === 200 || res.status === 201) {
											registerUser(payload, { setStatus, setSubmitting });
										}
										else {
											setSubmitting(false);
											setStatus('Recaptcha validation failed. please try again.');
										}
									}).catch(err => {
										setSubmitting(false);
										setStatus('Recaptcha validation failed. please try again.');
									});
								}}
								render={({ errors, status, touched, isSubmitting }) => (
									<Form className="mt-3" id="signup-form">
										<InputGroup className="mb-3">
											<InputGroupAddon addonType="prepend">
												<InputGroupText>
													<i className="ti-user"></i>
												</InputGroupText>
											</InputGroupAddon>

											<Field name="first_name" placeholder="First Name" type="text" className={'form-control' + (errors.first_name && touched.first_name ? ' is-invalid' : '')} onKeyPress={handleKeyPress} />
											<ErrorMessage name="first_name" component="div" className="invalid-feedback" />
										</InputGroup>
										<InputGroup className="mb-3">
											<InputGroupAddon addonType="prepend">
												<InputGroupText>
													<i className="ti-user"></i>
												</InputGroupText>
											</InputGroupAddon>

											<Field name="last_name" placeholder="Last Name" type="text" className={'form-control' + (errors.last_name && touched.last_name ? ' is-invalid' : '')} onKeyPress={handleKeyPress} />
											<ErrorMessage name="last_name" component="div" className="invalid-feedback" />
										</InputGroup>
										<InputGroup className="mb-3">
											<InputGroupAddon addonType="prepend">
												<InputGroupText>
													<i className="ti-email"></i>
												</InputGroupText>
											</InputGroupAddon>

											<Field name="email" placeholder="Email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} onKeyPress={handleKeyPress} />
											<ErrorMessage name="email" component="div" className="invalid-feedback" />
										</InputGroup>
										<InputGroup className="mb-3">
											<InputGroupAddon addonType="prepend">
												<InputGroupText>
													<i className="ti-lock"></i>
												</InputGroupText>
											</InputGroupAddon>
											<Field name="password" placeholder="Password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')}  onKeyPress={handleKeyPress} />
											<ErrorMessage name="password" component="div" className="invalid-feedback" />

										</InputGroup>
										<InputGroup className="mb-3">
											<InputGroupAddon addonType="prepend">
												<InputGroupText>
													<i className="ti-lock"></i>
												</InputGroupText>
											</InputGroupAddon>
											<Field name="confirm_password" placeholder="Confirm Password" type="password" className={'form-control' + (errors.confirm_password && touched.confirm_password ? ' is-invalid' : '')} onKeyPress={handleKeyPress} />
											<ErrorMessage name="confirm_password" component="div" className="invalid-feedback" />

										</InputGroup>

										<div className="form-group">
											<div className="form-check form-check-inline">
												<Field type="checkbox" name="acceptTermsOfUsage" className={'form-check-input' + (errors.acceptTermsOfUsage && touched.acceptTermsOfUsage ? ' is-invalid' : '')}  />
												<label className="form-check-label" htmlFor="acceptTermsOfUsage">
													I accept the &nbsp;<a style={linkStyle} href={'https://www.iubenda.com/terms-and-conditions/51840490'} target='_blank' rel='noopener noreferrer'>Terms of Usage</a>
													<ErrorMessage name="acceptTermsOfUsage" component="div" className="invalid-feedback" />
												</label>
											</div>

											<div className="form-check form-check-inline">
												<Field type="checkbox" name="acceptPrivacyPolicy" className={'form-check-input' + (errors.acceptPrivacyPolicy && touched.acceptTermsOfUsage ? ' is-invalid' : '')} />
												<label className="form-check-label" htmlFor="acceptPrivacyPolicy">
													I accept the &nbsp;<a style={linkStyle} href={'https://www.iubenda.com/privacy-policy/51840490/full-legal'} target='_blank' rel='noopener noreferrer'>Privacy Policy</a>
													<ErrorMessage name="acceptPrivacyPolicy" component="div" className="invalid-feedback" />
												</label>
											</div>

											<div className="form-check form-check-inline">
												<Field type="checkbox" name="acceptCookiePolicy" className={'form-check-input' + (errors.acceptCookiePolicy && touched.acceptCookiePolicy ? ' is-invalid' : '')} />
												<label className="form-check-label" htmlFor="acceptCookiePolicy">
													I accept the &nbsp;<a style={linkStyle} href={'https://www.iubenda.com/privacy-policy/51840490/cookie-policy'} target='_blank' rel='noopener noreferrer'>Cookie Policy</a>
													<ErrorMessage name="acceptCookiePolicy" component="div" className="invalid-feedback" />
												</label>
											</div>
										</div>

										<Row className="mb-3">
											<Col xs="12">
												<Button id="signup-submit" size="lg" color="primary" onClick={handleReCaptchaVerify} block disabled={isSubmitting}>Sign Up</Button>
											</Col>
										</Row>

										{status &&
											<div className={'alert alert-danger new-line'}>{status}</div>
										}

										<div className="justify-content-center d-flex align-items-center">
											Signed Up Already?
											<a
												href="/authentication/login"
												className="forgot text-cyan float-right"
												style={{paddingLeft: 6}}
											>Login</a>
										</div>

										<hr/>
										<h4 className="text-center text-bold">Or</h4>
										<SocialSignup />
									</Form>
								)}
							/>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	</div>
  );
};

export default SignUp;


